export default {
  hello: 'Hallo!',
  back: 'Zurück zur Suche',
  card: {
    label: 'Aktivitätsdetails anzeigen',
    infos: 'Informationen zur Aktivität',
    favorite: 'Zu Favoriten hinzufügen',
    new: 'Neue Aktivität',
    from: 'Ab ',
  },
  images: {
    gallery: 'Galerie',
    availabilities: 'Verfügbarkeiten anzeigen',
  },
  list: {
    label: 'Liste der Aktivitäten',
    total: 'gefundene Aktivitäten',
    load: 'Mehr anzeigen',
  },
  menu: {
    sorting: 'Sortieren nach',
    filters: 'Filter',
    relevance: 'Relevanz',
    price_asc: 'Preis (aufsteigend)',
    price_desc: 'Preis (absteigend)',
    ranking: 'Bewertung / Note',
    place: 'Ort',
    moment: 'Tageszeit',
    duration: 'Dauer',
    price: 'Preis',
    min: 'Min. Preis €',
    max: 'Max. Preis €',
    range: 'Verfügbar ',
    day: 'den ganzen Tag',
    from: 'von',
    to: 'bis',
    start: 'Min. Dauer (Std.):',
    end: 'Max. Dauer (Std.):',
  },
  search: {
    label: 'Aktivitätssuche',
    button: 'Suchen',
    cancel_button: 'Alles löschen',
    placeholder: 'Suchen',
    themes: 'Themen',
    activities: 'Aktivitäten',
    default: 'Meine Suche beginnen',
    dates: 'Alle Daten',
    togglethemes: 'Themen anzeigen',
    togglecalendar: 'Zeitraum auswählen',
  },
  timeRange: {
    morning: 'Am Morgen (von 8 Uhr bis Mittag)',
    afternoon: 'Am Nachmittag (von Mittag bis 17 Uhr)',
    evening: 'Am Abend (von 17 Uhr bis Mitternacht)',
  },
  activities: {
    label: 'Liste der Aktivitäten',
    left: 'Nach links verschieben',
    right: 'Nach rechts verschieben',
  },
  editor: {
    selection: {
      manual: 'Manuelle Auswahl',
      auto: 'Automatische Auswahl',
      validate: 'Meine Auswahl bestätigen',
      configure: 'Auswahl konfigurieren',
      summary: 'Zusammenfassung der Auswahl',
      from_any_provider: 'von beliebigen Anbietern',
    },
    searchEngine: {
      title: 'YouBOOK Widget Suchmaschine',
    },
    title: 'YouBOOK Widget Hervorhebung',
    create_widget: 'Widget erstellen',
    delete_all: 'Alles löschen',
    add_product: 'Aktivität hinzufügen',
    search_product: 'Produkt suchen ...',
    do_manual_selection: 'Manuelle Auswahl durchführen',
    show_results: 'Ergebnisse anzeigen',
  },
  filters: {
    places: 'Ort | Orte',
    types: 'Typ | Typen',
    themes: 'Thema | Themen',
    audiences: 'Zielgruppe | Zielgruppen',
    internals: 'Intern | Interne',
  },
  providers: {
    regiondo: 'Regiondo',
    welogin: 'WeLogin',
    guidap: 'Guidap',
    bokun: 'Bókun',
  },
  aria: {
    details: 'Angebotsdetails',
    presentation: 'Präsentation der Aktivität',
    cta: 'diese Aktivität jetzt buchen',
    cta_action: 'ein Datum buchen',
    provider_logo: 'Logo des Anbieters',
    highlights: 'Highlights der Aktivität',
    provider_book: 'Buchung beim Anbieter',
    crosselling: 'andere empfohlene Aktivitäten',
  },
  cta: {
    share: 'Teilen',
    price: 'Ab',
    book: 'Buchen',
    book_a_date: 'Ein Datum buchen',
    add_to_favorites: 'Zu Favoriten hinzufügen',
    retry: 'Erneut versuchen',
    next_session: 'Nächste Verfügbarkeit',
  },
  popover: {
    share: 'Diese Aktivität teilen:',
    go_to: 'Wie Sie dorthin kommen?',
  },
  content: {
    reviews: 'Bewertungen',
    recommended_by: 'Empfohlen von',
    available_soon: 'Aktivität bald verfügbar',
    available_today: 'Heute verfügbar',
    available_tomorrow: 'Ab morgen verfügbar',
    highlights: 'Highlights',
    options: 'Wählen Sie Ihre Daten, Ihre Optionen ...',
    fee: 'Keine Gebühren, gleicher Preis wie direkt',
    experience: 'Ihr Erlebnis',
    included: 'Inbegriffen',
    not_included: 'Nicht Enthalten',
    powered_by: 'Unterstützt von ',
    conditions: 'Bedingungen',
    essentials: 'Wesentliches',
    groups: 'Teilnehmer',
    other: 'Weitere',
    meeting_point: 'Treffpunkt',
    go_to: 'Anfahrt',
    address: 'Adresse :',
    how_to_go: 'Anreise:',
    transport: 'Transport:',
    book_peacefully: 'Buchen Sie sorgenfrei mit unserem Partner',
    complementary_infos: 'Zusätzliche Informationen',
    locality: 'Ort',
    other_activities: 'Das könnte Ihnen auch gefallen',
    eco_friendly: {
      title: 'Sie engagieren sich',
      description: 'Indem Sie die kohlenstoffarme Aktivität \« {activityName} \» wählen, reduzieren Sie Ihre Umweltauswirkungen erheblich.',
      detail: 'Eine kohlenstoffarme Aktivität emittiert kein oder sehr wenig CO2 aus fossilen Energiequellen.',
    },
    more: 'Mehr anzeigen',
    less: 'Weniger anzeigen',
  },
  cart: {
    disclaimer: 'Buchen Sie sorgenfrei über unseren technischen Partner.',
    article: '{count} Artikel | {count} Artikel',
    empty: 'Kein Warenkorb aktiv',
  },
  error: {
    data_unavailable: 'Die Informationen zu dieser Aktivität sind derzeit nicht verfügbar.',
  },
  map: {
    label: 'Karte',
    cta: 'Auf der Karte anzeigen',
    close: 'Karte schließen',
    filters: 'Filtern nach',
    filter: 'Filtern',
  },
};
